window.Sparkle ??= {};
window.Sparkle.Spotlight ??= {};

Sparkle.Spotlight.ItemDetails = class ItemDetails {
  constructor(item) {
    this.render = this.render.bind(this);
    this.clearItem = this.clearItem.bind(this);
    this.setItem = this.setItem.bind(this);
    this._build = this._build.bind(this);
    this.item = item;
    this.el = jQuery('<div class="spotlight-item-details">');
  }

  render() {
    this.el.empty();
    if (this.item) {
      this.el.append(this._build());
    }
    return this;
  }

  // HELPER FUNCTIONS

  clearItem() {
    return this.setItem();
  }

  setItem(item) {
    this.item = item;
    return this.render();
  }

  // PRIVATE

  _build() {
    const details = [];
    if (this.item.imageUrl) {
      details.push(jQuery('<img class="item-image">').src(this.item.imageUrl));
    }
    if (this.item.name) {
      details.push(jQuery('<span class="item-name">').html(this.item.name));
    }
    if (this.item.identifier) {
      details.push(jQuery('<span class="item-identifier">').html(this.item.identifier));
    }
    if (this.item.typeName) {
      details.push(jQuery(`<span class='item-type ${this.item.type}'>`).html(this.item.typeName));
    }
    if (this.item.id) {
      details.push(jQuery('<span class="item-id">').html(this.item.id));
    }
    if (this.item.createdAt) {
      details.push(jQuery('<span class="item-created-at">').html(this.item.createdAt));
    }
    if (this.item.updatedAt) {
      details.push(jQuery('<span class="item-updated-at">').html(this.item.updatedAt));
    }
    return details;
  }
};
